

export const ProgressBar = ({ progress }: { progress: number }) => {

    return (
        <div className="progress-bar-container">
            <div className="progress-bar-completed" style={{ width: `${progress}%` }} />
        </div>
    )
}
